import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import loginImage from '../../../assets/images/login-main.png';
import style from './ProjectCard.module.scss';
import useTheme from '../../../hooks/useTheme';
import { displayFirebaseImage } from '../../../services/firebaseImageLoader';

const ProjectCard = ({ project, handleNavigate }) => {
  const { theme, loaded } = useTheme(project?.builderId);
  const [imageUrl, setImageUrl] = useState();

  useEffect(() => {
    const func = async () => {
      const image = await displayFirebaseImage(
        project?.builderId,
        theme?.homepageBackgroundPath,
      );
      setImageUrl(image);
    };
    func();
  }, [project?.builderId, theme?.homepageBackgroundPath]);

  if (!project || !loaded) return null;

  return (
    <Box className={style.card} onClick={handleNavigate}>
      <img
        className={style.cardMedia}
        src={imageUrl ?? loginImage}
        alt={project.salescenterName}
      />
      <Box className={style.overlay}>
        <p className={style.projectName}>
          {project.salescenterName}
        </p>
        <Box className={style.bottomRow}>
          <span className={style.pdi}>
            {project.pdiProject ? 'Closeout & Warranty' : ''}
          </span>
          <ArrowForwardIcon className={style.arrow} />
        </Box>
      </Box>
    </Box>
  );
};

export default ProjectCard;
